import { render, staticRenderFns } from "./coursePaper.vue?vue&type=template&id=669f5ff7&scoped=true&"
import script from "./coursePaper.vue?vue&type=script&lang=js&"
export * from "./coursePaper.vue?vue&type=script&lang=js&"
import style0 from "./coursePaper.vue?vue&type=style&index=0&id=669f5ff7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f5ff7",
  null
  
)

export default component.exports